import { render, staticRenderFns } from "./HonorLiveMobile.vue?vue&type=template&id=47fd5c62&scoped=true"
import script from "./HonorLiveMobile.vue?vue&type=script&lang=js"
export * from "./HonorLiveMobile.vue?vue&type=script&lang=js"
import style0 from "./HonorLiveMobile.vue?vue&type=style&index=0&id=47fd5c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd5c62",
  null
  
)

export default component.exports